import React from 'react';
import { Link } from 'react-router-dom';
import './LandingFooter.css';

interface LandingFooterProps {
  onCookiePreferences?: () => void;
}

export default function LandingFooter({ onCookiePreferences }: LandingFooterProps) {
  return (
    <footer className="landing-footer">
      <div className="landing-footer__inner">
        <div className="landing-footer__mark">
          <span className="landing-footer__glyph" aria-hidden="true">◆</span>
          <span className="landing-footer__name">MySecureRoom</span>
          <span className="landing-footer__version" aria-hidden="true">v2.0 · building in the open</span>
        </div>

        <p className="landing-footer__tagline">
          End-to-end encrypted · Zero knowledge · Your keys, your data
        </p>

        <div className="landing-footer__links">
          <span className="landing-footer__copy">© 2026 Ahad Software House</span>
          <span className="landing-footer__sep" aria-hidden="true">·</span>
          <Link to="/privacy" className="landing-footer__link">Privacy</Link>
          <span className="landing-footer__sep" aria-hidden="true">·</span>
          <Link to="/terms" className="landing-footer__link">Terms</Link>
          {onCookiePreferences && (
            <>
              <span className="landing-footer__sep" aria-hidden="true">·</span>
              <button
                type="button"
                onClick={onCookiePreferences}
                className="landing-footer__link landing-footer__link--btn"
              >
                Cookie preferences
              </button>
            </>
          )}
        </div>
      </div>
    </footer>
  );
}
